import React from 'react';

import TitleField from '../text/TitleField';
import TextField from '../text/TextField';
import ProductPreview from '../design/ProductPreview';
import ContentTitle from '../text/ContentTitle';
import { StaggerGroup, StaggerItem } from '../motion/Stagger';

import boathouserRenteeFrame from '../../images/products/boathouserentee/boathouseRenteeFrame.png';
import boathouserRenterFrame from '../../images/products/boathouserenter/renterFormIphoneFrame.png';
import nicheWalletFrame from '../../images/products/nichewallet/nicheWalletFrame.png';

import '../../styles/home/ProductsOverview.css';



const ProductsOverview = () => {
    
    const products = [
         {
            imgSource: boathouserRenteeFrame,
            title: "Boathouse Rentee App",
            description: "Staff dashboard to manage queues, reservations, and watercraft in real time.",
            orientation: "vertical",
            deviceType: "tablet",
            to: "/products#boathouse-rentee-app"
        },
        {
            imgSource: boathouserRenterFrame,
            title: "Boathouse Renter App",
            description: "Residents scan a QR code, submit a rental request, and receive a text when their watercraft is ready.",
            orientation: "vertical",
            deviceType: "phone",
            to: "/products#boathouse-renter-app"
        },
        {
            imgSource: nicheWalletFrame,
            title: "NicheWallet",
            description: "A secure wallet app for storing and managing all your RA-issued cards.",
            orientation: "horizontal",
            deviceType: "phone",
            to: "/products#nichewallet"
        }
    ];

    return (
        <>
            <div className="home-products-overview-container">

                <ContentTitle title='Our Custom Software Products' 
                    subTitle='Powerful, easy-to-use solutions built for real-world operations'/>

                <StaggerGroup as="div" className="home-products-overview-display-container" scroll staggerChildren={0.15} amount={0.15}>
                    {products.map((product) => (
                        <StaggerItem as="div" key={product.title}>
                            <ProductPreview
                                imgSource={product.imgSource}
                                title={product.title}
                                description={product.description}
                                orientation={product.orientation}
                                deviceType={product.deviceType}
                                to={product.to}
                            />
                        </StaggerItem>
                    ))}
                </StaggerGroup>

            </div>
        </>

    );
}


export default ProductsOverview;
